import { render } from "./FosoftechBrand.vue?vue&type=template&id=49488941&scoped=true"
import script from "./FosoftechBrand.vue?vue&type=script&lang=js"
export * from "./FosoftechBrand.vue?vue&type=script&lang=js"

import "./FosoftechBrand.vue?vue&type=style&index=0&id=49488941&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-49488941"]])

export default __exports__